<template>
  <icon-component v-bind="$props">
    <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M60.533 48.885a37.501 37.501 0 0 0-14.4 15.68 37.524 37.524 0 0 0-17.066-17.141 37.675 37.675 0 0 0 17.066-17.141 37.595 37.595 0 0 0 14.368 15.669l5.451-5.45c-7.488-3.905-13.13-10.87-15.264-19.222-.213-.832-.672-3.797-.704-4.587a2.976 2.976 0 0 0-2.965-2.837h-1.782a2.969 2.969 0 0 0-2.965 2.837c-.032.779-.49 3.755-.704 4.587-2.699 10.581-11.04 18.933-21.621 21.653h-.043c-1.045.278-2.955.427-4.576.523a2.971 2.971 0 0 0-2.805 2.965v2.006a2.97 2.97 0 0 0 2.805 2.965c1.621.085 3.53.245 4.576.512h.043C30.56 54.645 38.923 63.04 41.589 73.685c.118.459.342 2.784.512 4.715a2.969 2.969 0 0 0 2.955 2.71h2.133a2.969 2.969 0 0 0 2.955-2.71c.17-1.92.395-4.256.512-4.715 2.112-8.416 7.787-15.434 15.328-19.349l-5.45-5.45ZM87.211 47.404 77.195 57.419l-5.376-5.365-4.64-4.65 10.016-10.017 10.016 10.017Z"
        fill="currentColor"
      />
    </svg>
  </icon-component>
</template>

<script>
  import IconComponent from './IconComponent.vue';

  export default {
    components: {
      IconComponent,
    },
    extends: IconComponent,
  };
</script>
